




import React, { useEffect, useState } from "react";
import axios from "axios";

const FilterSidebar = ({
  showFilters,
  toggleFilters,
  selectedCategory,
  handleCategoryFilter,
  selectedSubCategory,
  handleSubCategoryFilter,
  minPrice,
  maxPrice,
  handlePriceFilter,
}) => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [localMin, setLocalMin] = useState(minPrice || 0);
  const [localMax, setLocalMax] = useState(maxPrice || 10000);

  // Fetch Categories
  useEffect(() => {
    axios
      .get("https://vantara.datacubeglobal.com/api/api-categories")
      .then((res) => {
        if (res.data.status === "success") {
          setCategories([{ id: "all", name: "All" }, ...res.data.data]);
        }
      })
      .catch((err) => console.error("Error fetching categories:", err));
  }, []);

  
  useEffect(() => {
    if (!selectedCategory || selectedCategory.id === "all") {
      setSubCategories([]);
  
      return;
    }

    axios
      .get(
        `https://vantara.datacubeglobal.com/api/api-sub-categories/${selectedCategory.id}`
      )
      .then((res) => {
        if (res.data.status === "success") {
          setSubCategories(res.data.data); 
        
        }
      })
      .catch((err) => console.error("Error fetching subcategories:", err));
  }, [selectedCategory]);

  return (
    <>
      {/* Backdrop */}
      <div
        className={`filter-backdrop ${showFilters ? "show" : ""}`}
        onClick={toggleFilters}
      />

      {/* Sidebar */}
      <div className={`filter-sidebar ${showFilters ? "open" : ""}`}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold">Filters</h5>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={toggleFilters}
          >
            <i className="bi bi-x"></i>
          </button>
        </div>

        {/* Category */}
        <div className="mb-4">
          <h6 className="mb-3 ">Category</h6>
          <div className="list-group">
            {categories.map((category) => (
              <button
                key={category.id}
                  style={selectedCategory?.id === category.id ? { backgroundColor: '#7c0046', color: '#fff' } : {}}
                className={`list-group-item list-group-item-action border-0 rounded ${selectedCategory?.id === category.id ? "active" : ""
                  }`}
                onClick={() => handleCategoryFilter(category)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Sub-category */}
        {selectedCategory && selectedCategory.id !== "all" && subCategories.length > 0 && (
          <div className="mb-4">
            <h6 className="mb-3">Sub Categories</h6>
            <div className="list-group">
              {subCategories.map((sub) => (
                <button
                  key={sub.id}
                  className={`list-group-item list-group-item-action border-0 rounded ${selectedSubCategory?.id === sub.id ? "active" : ""
                    }`}
                  onClick={() => handleSubCategoryFilter(sub)}
                >
                  {sub.sub_cat_name}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Price Range */}
        <div className="mb-4">
          <h6 className="mb-3">Price Range (₹)</h6>
          <div className="d-flex gap-2">
            <input
              type="number"
              className="form-control"
              placeholder="Min"
              value={localMin}
              onChange={(e) => setLocalMin(e.target.value)}
            />
            <input
              type="number"
              className="form-control"
              placeholder="Max"
              value={localMax}
              onChange={(e) => setLocalMax(e.target.value)}
            />
          </div>
          <button
            className="btn btn-sm btn-outline-dark mt-2 w-100"
            onClick={() => handlePriceFilter(localMin, localMax)}
          >
            Apply Price
          </button>
        </div>

        <button
          className="btn w-100"
          style={{
            backgroundColor: "#0C420EFF",
            color: "#fff",
          }}
          onClick={toggleFilters}
        >
          Apply Filters
        </button>
      </div>
    </>
  );
};

export default FilterSidebar;

